import 'jquery-validation'
import 'jquery-validation/dist/additional-methods.js'

export function initJQueryValidation(rulesObj) {
  $.validator.setDefaults({
    debug: false,

    // submitHandler: function () {
    //     alert( "submitted!" )
    // }
  })

  let orderPaymentForm
	if ($('#order-payment-form').length > 0) {
		orderPaymentForm = $('#order-payment-form')
	} else if ($('#orderhelper-payment-form').length > 0) {
		orderPaymentForm = $('#orderhelper-payment-form')
	}

	// const validator = orderPaymentForm.validate()
	if (orderPaymentForm && orderPaymentForm.validate()) {
		orderPaymentForm.validate().destroy()
	}

  orderPaymentForm.validate({
    debug: false,
    rules: rulesObj,
    messages: {
      firstName: window.myvars.firstNameMsg,
      lastName: window.myvars.lastNameMsg,
      address1: window.myvars.address,
      city: window.myvars.city,
      zip: window.myvars.zip,
      stateId: window.myvars.stateId,
      phone: window.myvars.phoneMessage,
      email: window.myvars.email,
      'email-capture': window.myvars.emailCapture,
      creditCardName: window.myvars.creditCardName,
      creditCardNumber: window.myvars.creditCardNumber,
      cvv2Number: window.myvars.cvv2Number,
      firstNameBilling: window.myvars.billingfirstNameMsg,
      lastNameBilling: window.myvars.billinglastNameMsg,
      address1Billing: window.myvars.addressBilling,
      zipBilling: window.myvars.zipBilling,
      cityBilling: window.myvars.cityBilling,
      emailBilling: window.myvars.emailBilling,
			cpfBilling: window.myvars.cpfBilling,
			cpfBillingPix: window.myvars.cpfBillingPix,
      phoneBilling: window.myvars.phoneBilling,
      idealName: window.myvars.idealName,
      idealBank: window.myvars.idealBank,
      przelewy24Name: window.myvars.przelewy24Name,
      przelewy24Email: window.myvars.przelewy24Email,
      sofortCountry: window.myvars.sofortCountry,
      convenienceStoreType: window.myvars.convenienceStoreType,
      konbiniLastName: window.myvars.konbiniLastName,
      konbiniFirstName: window.myvars.konbiniFirstName,
      konbiniEmail: window.myvars.konbiniEmail,
      konbiniPhone: window.myvars.konbiniPhone,
      bankTransferLastName: window.myvars.bankTransferLastName,
      bankTransferFirstName: window.myvars.bankTransferFirstName,
      bankTransferEmail: window.myvars.bankTransferEmail,
      bankTransferPhone: window.myvars.bankTransferPhone,
      twintLastName: window.myvars.twintLastName,
      twintFirstName: window.myvars.twintFirstName,
      twintEmail: window.myvars.twintEmail,
      twintPhone: window.myvars.twintPhone,
      paypayLastName: window.myvars.paypayLastName,
      paypayFirstName: window.myvars.paypayFirstName,
      paypayEmail: window.myvars.paypayEmail,
      paypayPhone: window.myvars.paypayPhone,
      buyername: window.myvars.buyername,
      buyertel: window.myvars.buyertel,
      buyeremail: window.myvars.buyeremail,
      nameBilling: window.myvars.nameBilling,
    },
    errorElement: 'em',
    errorPlacement(error, element) {
      // Add the `help-block` class to the error element
      error.addClass('help-block')

      if (element.prop('type') === 'checkbox') {
        error.insertAfter(element.parent('label'))
      } else {
        error.insertAfter(element)
        // element.find('div').remove()
      }
    },
    highlight(element, errorClass, validClass) {
      showValidatorError(element)
    },
    unhighlight(element, errorClass, validClass) {
      hideValidatorError(element)
    },
    onkeyup(element, event) {
      // Tab (and other non-input keys) can fire keyup on the newly focused field;
      // skip those so focus-via-keyboard does not immediately show "required" errors.
      if (event) {
        if (event.which === 9 || event.key === 'Tab') {
          return
        }

        const excludedKeys = [
          16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225,
        ]

        if ($.inArray(event.keyCode, excludedKeys) !== -1) {
          return
        }
      }

      this.element(element) // eager validation on real typing
    },
    onfocusout(element) {
      // show error when input:
      // this.element(element) // <- "eager validation"
    },
    focusCleanup: false,
  })

  $.validator.methods.email = function (value, element) {
    return (
      this.optional(element) ||
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value
      )
    )
  }

  $.validator.methods.cpf = function (value, element) {
    return (
      this.optional(element) || validate_cpf(value)
    )
  }

	if (window.iti && window.phoneCountryCode === 'us') {
		$.validator.methods.phone = function (value, element) {
			return (
				phoneRules(false)
			)
		}
	}

	if (window.itiBilling && window.phoneCountryCodeBilling === 'us') {
		$.validator.methods.phoneBilling = function (value, element) {
			return (
				phoneRules(true)
			)
		}
	}

  $.validator.methods.creditcardtypes = function (value, element, param) {
    if (/[^0-9\-]+/.test(value)) {
      return false;
    }

    value = value.replace(/\D/g, "");

    var validTypes = 0x0000;

    if (param.mastercard) {
      validTypes |= 0x0001;
    }
    if (param.visa) {
      validTypes |= 0x0002;
    }
    if (param.amex) {
      validTypes |= 0x0004;
    }
    if (param.dinersclub) {
      validTypes |= 0x0008;
    }
    if (param.enroute) {
      validTypes |= 0x0010;
    }
    if (param.discover) {
      validTypes |= 0x0020;
    }
    if (param.jcb) {
      validTypes |= 0x0040;
    }
    if (param.unknown) {
      validTypes |= 0x0080;
    }
    if (param.all) {
      validTypes = 0x0001 | 0x0002 | 0x0004 | 0x0008 | 0x0010 | 0x0020 | 0x0040 | 0x0080;
    }
    if (validTypes & 0x0001 && (/^(5[12345])/.test(value) || /^(2[234567])/.test(value))) { // Mastercard
      return value.length === 16;
    }
    if (validTypes & 0x0002 && /^(4)/.test(value)) { // Visa
      return value.length === 16;
    }
    if (validTypes & 0x0004 && /^(3[47])/.test(value)) { // Amex
      return value.length === 15;
    }
    if (validTypes & 0x0008 && /^(3(0[012345]|[68]))/.test(value)) { // Dinersclub
      return value.length === 14;
    }
    if (validTypes & 0x0010 && /^(2(014|149))/.test(value)) { // Enroute
      return value.length === 15;
    }
    if (validTypes & 0x0020 && /^(?:6011\s?-?\d{12}|64[4-9]\s?-?\d{13}|65\s?-?\d{14})(?:[\s-]?)$/.test(value)) { // Discover
      return value.length === 16;
    }
    if (validTypes & 0x0040 && /^(3)/.test(value)) { // Jcb
      return value.length === 16;
    }
    if (validTypes & 0x0040 && /^(2131|1800)/.test(value)) { // Jcb
      return value.length === 15;
    }
    if (validTypes & 0x0080) { // Unknown
      return true;
    }
    return false;
  }


}

function phoneRules(isBilling) {
  try {
    return isBilling ? window.itiBilling.isValidNumber() : window.iti.isValidNumber();
  } catch (error) {
    console.error('Phone validation error:', error);
    return false;
  }
}

function hideValidatorError(elm) {
  $(elm)
    .parents('.address-form-item, .fp-email-top')
    .addClass('has-success')
    .removeClass('has-error')
}

function showValidatorError(elm) {
  $(elm)
    .parents('.address-form-item, .fp-email-top')
    .addClass('has-error')
    .removeClass('has-success');
  if (!window.isMobile && !$(elm).is(':focus') && $(document.activeElement).attr('id') !== 'expDateYear') {
	  if ($('.has-error').length > 0) {
			$('html, body').animate({
				scrollTop: $('.has-error').offset().top - 100,
			}, 200);
		}
  }
}

/** Re-run validation on fields Google Places autofill updates by value (no input events). */
export function revalidateAddressFieldsAfterGoogleAutofill(isBilling) {
  let orderPaymentForm
  if ($('#order-payment-form').length > 0) {
    orderPaymentForm = $('#order-payment-form')
  } else if ($('#orderhelper-payment-form').length > 0) {
    orderPaymentForm = $('#orderhelper-payment-form')
  }

  if (!orderPaymentForm?.length) {
    return
  }

  const validator = orderPaymentForm.data('validator')

  if (!validator || !window.addressObj) {
    return
  }

  const suffix = isBilling ? 'Billing' : ''
  const attrSuffix = isBilling ? 'billing' : ''
  const run = (jq) => {
    if (jq && jq.length) {
      validator.element(jq)
    }
  }

  run($(`#address1${suffix}`))

  Object.keys(window.addressObj).forEach((key) => {
    if (['state', 'country'].includes(key)) {
      run($(`#${key}Id${suffix}`))
    } else {
      $(`[data-address-key${attrSuffix}="${key}"]`).each(function () {
        run($(this))
      })
    }
  })
}

export default initJQueryValidation
